import moment from "moment/moment.js";
import React, { useCallback, useState } from "react";
import { useEffect } from "react";
import useDropdownMenu from "react-accessible-dropdown-menu-hook";
import config from "../../config/config.js";
import tools from "../../lib/tools.js";
import business from "../../services/business.js";
import Loading from "../Loading.js";
import createPushClient from "../../lib/pushClient.js";
import { toast as alert } from "react-toastify";

const NOTIFICATION_CACHE_TTL = 60 * 1000;
const NOTIFICATION_CACHE_KEY = 'notifications';
const NOTIFICATION_CACHE_TIME_KEY = 'notifications_cached_at';

export default function Notificacao({ className = '' }) {
  const { buttonProps, isOpen, setIsOpen } = useDropdownMenu(1);
  const [notificacoes, setNotificacoes] = useState([]);
  const [loadStatus, setLoadStatus] = useState(false);
  const [renderId, setRenderId] = useState(false);

  const fetchData = useCallback(async (update = false) => {
    const data = localStorage.getItem(NOTIFICATION_CACHE_KEY);
    const cachedAt = Number(localStorage.getItem(NOTIFICATION_CACHE_TIME_KEY) || 0);
    const cacheIsFresh = Date.now() - cachedAt < NOTIFICATION_CACHE_TTL;

    if (data && cacheIsFresh && !update) {
      setNotificacoes(JSON.parse(data) || []);
      return;
    }

    setLoadStatus(true);
    console.log(`Notificações: lendo notificações`)

    let response = await business.getNotificacaoAlerta();
    if (response) {
      setNotificacoes(response)
      localStorage.setItem(NOTIFICATION_CACHE_KEY, JSON.stringify(response));
      localStorage.setItem(NOTIFICATION_CACHE_TIME_KEY, String(Date.now()));
      console.log(`Notificações: completo`)
    }

    setLoadStatus(false);
  }, []);

  // ================================
  // PUSH CLIENT – Notificações
  // ================================

  useEffect(() => {

    const wsURL = process.env.REACT_APP_PUSH_WS_URL;
    const push = createPushClient(wsURL);

    // Notificações gerais por tipo
    const tipoUsuario = parseInt(config.user.tipo) ?? null;

    if (tipoUsuario) {

      const canalTipo = `saa-tipo-${tipoUsuario}`;
      console.log(`[PUSH-NOTIF] Assinando canal: ${canalTipo}`);

      const chTipo = push.subscribe(canalTipo);

      chTipo.bind("update", (payload) => {
        console.log(`[PUSH-NOTIF] Recebido em :${canalTipo}`, payload);

        const { mensagem, id_usuario } = payload || {};

        if (config.user?.id && parseInt(config.user.id) !== parseInt(id_usuario)) {
          alert.success(mensagem);
          fetchData(true);
        }
      });
    }

    // Notificação individual por usuário
    const canalUser = `saa-usuario-${config.user?.id}`;
    console.log(`[PUSH-NOTIF] Assinando canal: ${canalUser}`);

    const chUser = push.subscribe(canalUser);

    chUser.bind("update", (payload) => {
      console.log(`[PUSH-NOTIF] Recebido em ${canalUser}:`, payload);

      const { mensagem, id_usuario } = payload || {};

      if (config.user?.id && parseInt(config.user.id) !== parseInt(id_usuario)) {
        alert.success(mensagem);
        fetchData(true);
      }
    });

  }, [fetchData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (isOpen) {
      fetchData();
    }
  }, [isOpen, fetchData]);

  const totalNaoLido = (notificacoes || []).filter((item) => {
    return parseInt(item.lido) === 0;
  })?.length || 0;

  const marcarComoLido = async (id, i, callback = false) => {
    const response = await business.setNotificacaoLida(id);
    if (response?.status) {
      notificacoes[i].lido = true;
      setNotificacoes(notificacoes);
      localStorage.setItem(NOTIFICATION_CACHE_KEY, JSON.stringify(notificacoes));
      localStorage.setItem(NOTIFICATION_CACHE_TIME_KEY, String(Date.now()));
      setRenderId(tools.uuidv4());
      if (callback) {
        callback();
      }
    }
  }

  useState(() => { }, [renderId]);

  return (
    <div className={`relative ${className}`} id="widget-notifications">
      <div className={`icone-notificacao ${isOpen && 'active'}`}>
        <i className="icon icon-bell blue i-20 pointer" onClick={(e) => e.stopPropagation()}  {...buttonProps} />
      </div>
      {totalNaoLido > 0 && <div className="alerta f700-10 flex ai-fc jc-fc">{totalNaoLido}</div>}
      <div className={`dropdown-submenu header-notificacoes ${isOpen ? 'visible' : ''} flex fd-fc`} role='menu'>
        <h1 className="flex jc-sb ai-fc f200-16 m-10 ml-20 mr-20">
          Notificações
          <span className="close pointer" onClick={() => setIsOpen(false)}>
            <i className="icon icon-cross-small i-25 watermelon" />
          </span>
        </h1>
        <div className="flex fd-fc container-notificacao scrollfit">
          {!loadStatus && (notificacoes || []).map((n, i) => {
            return <div key={`notificacao-${i}`}>
              <div className={`flex ai-fc notificacao ${(parseInt(n.lido) === 0) ? 'nao-lido' : ''} mb-15 pointer gap-15`} onClick={() => marcarComoLido(n.id, i)} >
                <div className="flex fd-fc" onClick={() => {

                  let url_redirect = `/${n.slug}/${n.id_processo}`;

                  // auto open tab chat
                  if (n?.id_acao && parseInt(n.id_acao) === 790) {
                    url_redirect += '#comentarios';
                  }

                  if (parseInt(n.lido) === 0) {
                    marcarComoLido(n.id, i, () => {
                      tools.openURL(url_redirect);
                    });
                  } else {
                    tools.openURL(url_redirect);
                  }
                }}>
                  <p className="f400-14 mb-5"><span className="link">ID: {n.id_protocolo}</span> - {n.desc_tipo_processo}</p>
                  <p className="f400-14 m-0"><b>{n.desc_acao}</b></p>
                  <p className="f400-12 junta_medica mv-5">{n.id_acao !== '100' ? n.desc_processo_etapa + ': ' + n.desc_processo_etapa_status : ''}</p>
                  <p className="f400-12 junta_medica mv-5">{moment(n.data_criacao, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY - HH:mm')} hrs</p>
                  <p className="f400-12 junta_medica">Assistente: {n.nome_assistente ? n.nome_assistente : 'Não informado.'} | Enfermeira: {n.nome_enfermeira ? n.nome_enfermeira : 'Não informado.'}</p>
                </div>
                {n.lido && <div className="alert-nao-lido" />}
              </div>
              <div className="line-bottom" />
            </div>
          })}
          {loadStatus && <div className="flex ai-fc notificacao"><Loading /></div>}
        </div>
      </div>
    </div>
  );
}

